import {PartyRole, TrustPurpose} from '@sollapay/enums';

import {StandardTrustType} from './trust-type.strategy';

/** מכר יזם — a buyer purchases directly from a developer; a 7% deposit passes through the trust. */
class SevenPercentTrustType extends StandardTrustType {
  readonly purpose = TrustPurpose.SEVEN_PERCENT;
  readonly maxCollectionPercentage = 7;

  getBuyerPartyRoles(): PartyRole[] {
    return [PartyRole.BUYER, PartyRole.BENEFICIARY];
  }

  override readonly showsBeneficiaryAddCta = false;
}

export const sevenPercentTrustType = new SevenPercentTrustType();
